import React from 'react';
import ArrowButton from '../../common/button-arrow';

const MIN_ORDER_QUANTITY = 10;

const ConfirmOrderButton = ({ orderQty, disabled, color, block, className, arrow }) => {
  return (
    <div className={className}>
      <ArrowButton
        className="w-full"
        color={color}
        arrow={arrow}
        disabled={disabled || orderQty < MIN_ORDER_QUANTITY}
        block={block}>CONFIRM ORDER</ArrowButton>
      {orderQty < MIN_ORDER_QUANTITY &&
      <span className="confirm-order-button-message">
        Please note there is a minimum order quantity of 10 outers,
        please add additional products or save your order for later
     </span>}
    </div>
  );
};

export default ConfirmOrderButton;



// WEBPACK FOOTER //
// ./src/components/new-order/confirm/confirm-order-button.jsx